<template>

    <!-- form_block -->
    <div class="row form_block mt_sm">
        <div class="col-12">
            <form action="">

                <div class="info_title form_block_title">
                    <b>Новый адрес</b>
                </div>
                <div class="info_body">
                    <div class="form-group">
                        <label for="fb_01_01">Введите полный адрес</label>
                        <input type="text" class="form-control" name="address" id="deliveryAddress" 
                            :class="{ 'is-invalid': errors.address }"
                            v-model="form.address">
                        <small id="" class="text-muted">Например, Россия, 117519, Новосибирская обл., г.
                            Новосибирск, ул. Береговая, д. 11, корп. 2, стр. 1.</small>
                    </div>
                    <button type="button" class="btn btn_lg btn_common mt_xxs" 
                        @click.prevent="checkForm" :disabled="disabled">
                        {{ disabled ? 'Сохраняем...' : 'Сохранить' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
    <!-- //form_block -->

</template>

<script>
export default {
    data: function () {
        return {
            errors: {},
            address: ''
        }
    },
    methods: {
        checkForm: function (e) {
            this.errors = {};

            let fields = [];

            fields = ['address'];

            for (let i = 0; i < fields.length; i++) {
                if (this.form[fields[i]] == '' || this.form[fields[i]] == null) {
                    this.errors[fields[i]] = 1;
                }
            }

            // if form is valid
            if (Object.keys(this.errors).length == 0) {
                this.addAddress();
                this.resetForm();
            }
        },
        
        resetErrors: function (e) {
            this.errors = {};
        },
        
        resetForm: function (e) {
            this.resetErrors();
            this.$store.commit("delivery/resetForm");
        },

        addAddress() {
            this.$store.dispatch("delivery/addAddress");
        },

        // updatePayer() {
        //     this.$store.dispatch("delivery/updateAddress");
        //     this.resetForm();
        // },
    },
    computed: {
        form() {
            return this.$store.state.delivery.address;
        },
        disabled() {
            return this.$store.state.delivery.saving;
        },
    },
};
</script>
